import { z } from 'zod';

export const searchSchema = z.object({
  // Basic Info fields (FormField only)
  ngay_ct1: z.string().optional(), // From date
  ngay_ct2: z.string().optional(), // To date
  ct_vt: z.boolean().optional(), // Material details flag
  so_du: z.boolean().optional(), // Balance calculation flag

  // Details Tab fields (FormField only)
  nguoi_lap: z.string().optional(), // Creator
  mau_bc: z.number().optional() // Report template
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  ngay_ct1: '', // From date
  ngay_ct2: '', // To date
  ct_vt: false, // Material details flag
  so_du: false, // Balance calculation flag
  nguoi_lap: '', // Creator
  mau_bc: 20 // Report template (default value from backend)
};
